import React, { useEffect, useState, useContext, useRef, useImperativeHandle } from "react";
import { Link, useLocation } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import api from "services/api";

import { Card } from "@mui/material";
import Grid from "@mui/material/Grid";

import Tooltip from "@mui/material/Tooltip";
import Pagination from "@mui/material/Pagination";

import SuiBadge from "components/SuiBadge";
import SuiTypography from "components/SuiTypography";
import SuiBadgeDot from "components/SuiBadgeDot";
import SuiBox from "components/SuiBox";
import SuiAvatar from "components/SuiAvatar";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import ButtonGroup from "@mui/material/ButtonGroup";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import SearchIcon from "@mui/icons-material/Search";

import { capitalCase } from "capital-case";
import { AccountContext } from "context/account";
import CategoryContext from "context/category-context";
import MyProjectsContext from "context/my-projects";

import Prompt from "components/UpStyled/Prompt";
import toast from "react-hot-toast";
import moment from "moment";
import qs from "query-string";
import { useForm, Controller } from "react-hook-form";
import { DatePicker, Empty } from "antd";

import { projectSortOptions, projectStatusOptions, budgetOptions } from "utils/data";
import { collectionSortOptions } from "utils/data";

import ProjectCard4 from "components/UpStyled/project-card/ProjectCard4";
import CollectionCard from "components/UpStyled/CollectionCard";

const sortKeys = ["init", "requested", "active", "completed", "canceled"];
const sortKeys_reverse = ["canceled", "completed", "active", "requested", "init"];

const ImportCollectionModal = React.forwardRef(
  (
    {
      visible,
      handleClose,
      handleOk,
      isEdit = false,
      categoryTree = [],
      collection,
      handleRefresh = () => {},
      selectedItems = [],
      stage = "all",
    },
    ref
  ) => {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [searchStr, setSearchStr] = useState("");
    const [orderOpt, setOrderOpt] = useState(collectionSortOptions[4]);

    const [filterObj, setFilterObj] = useState({});
    const [checked, setChecked] = useState({});
    const [totalNumber, setTotalNumber] = useState(0);

    const [selectedCollections, setSelectedCollections] = useState([]);
    const [collectionList, setCollectionList] = useState([]);
    const [filteredCollectionList, setFilteredCollectionList] = useState([]);

    useImperativeHandle(
      ref,
      () => ({
        selectedCollections,
        setSelectedCollections,
      }),
      [selectedCollections]
    );

    const {
      register,
      handleSubmit,
      trigger,
      setValue,
      watch,
      getValues,
      reset,
      formState: { errors },
      control,
    } = useForm();

    useEffect(() => {
      if (visible) {
        let temp = {};
        for (let i = 0; i < selectedItems.length; i++) {
          temp[selectedItems[i]?.id] = true;
        }
        setSelectedCollections(selectedItems);
        setChecked(temp);
      }
    }, [visible]);

    useEffect(() => {
      if (visible) {
        retrieveCollections();
      }
    }, [visible]);

    const retrieveCollections = async (sort = "") => {
      try {
        const { data } = await api.collections.list({ order: "-updated_at" });

        let collections = data["collections"] ? data["collections"] : [];

        collections = collections.map((x) => ({
          ...x,
          season: x?.metadata?.season?.value || "",
          year: x?.metadata?.year || "",
        }));
        setCollectionList(collections);
        setTotalNumber(collections.length);

        //filter based on pagination
        const sliceStart = pageSize * (page - 1);
        const sliceEnd =
          pageSize * page > collections.length ? collections.length : pageSize * page;
        const newFilteredList = collections.slice(sliceStart, sliceEnd);

        setFilteredCollectionList(newFilteredList);
      } catch (err) {
        toast.error(`Retrieve collection list failed`);
        console.log(err);
      }
    };

    const handleFilterCollections = (page, pageSize, str = searchStr) => {
      const copyProjects = [...collectionList];
      let filteredList = copyProjects; //all projects

      if (str) {
        const strUpper = str.toUpperCase();
        const searchFields = ["title", "description"];
        filteredList = filteredList.filter((x) => {
          let result = false;
          for (let i = 0; i < searchFields.length; i++) {
            if (x[searchFields[i]]) {
              if (typeof x[searchFields[i]] == "string") {
                if (x[searchFields[i]].toUpperCase().includes(strUpper)) {
                  result = true;
                }
              } else if (typeof x[searchFields[i]] == "object") {
                const text = JSON.stringify(x[searchFields[i]]);
                if (text.toUpperCase().includes(strUpper)) {
                  result = true;
                }
              }
            }
          }
          return result;
        });
      }

      setTotalNumber(filteredList.length);

      let newPage = page;
      //filter based on pagination
      const sliceStart = pageSize * (newPage - 1);
      const sliceEnd =
        pageSize * newPage > filteredList.length ? filteredList.length : pageSize * newPage;
      const newFilteredList = filteredList.slice(sliceStart, sliceEnd);
      setFilteredCollectionList(newFilteredList);
    };

    const handleChangePage = (event, newPage) => {
      setPage(newPage);
      handleFilterCollections(newPage, pageSize, searchStr);
    };

    const handleChangeRowsPerPage = (option) => {
      const newPageSize = parseInt(option.value, 10);
      setPageSize(newPageSize);
      setPage(1);
      handleFilterCollections(1, newPageSize, searchStr);
    };

    const pageCount = parseInt(Math.ceil(totalNumber / pageSize), 10);
    const pageOptions = [];
    for (let i = 0; i < pageCount; i++) {
      pageOptions.push(i);
    }
    const entriesStart = pageSize * (page - 1) + 1;
    const entriesEnd = pageSize * page > totalNumber ? totalNumber : pageSize * page;

    const handleSearchChange = (str) => {
      let formattedStr = "";
      if (str) {
        formattedStr = str.trim();
      }
      setSearchStr(formattedStr);
      handleFilterCollections(page, pageSize, formattedStr);
    };

    const handleOnSortChange = (e) => {
      setOrderOpt(e);
      let sortStr = e?.value;
      const newFilteredCollectionList = filteredCollectionList.sort((a, b) =>
        compare(a, b, sortStr)
      );
      setFilteredCollectionList(newFilteredCollectionList);
    };

    const handleCheckProject = (p) => {
      if (checked[p.id] == true) {
        // product was already in the list, then uncheck it
        const newSelectedProjects = selectedCollections.filter((x) => x.id != p.id);
        setSelectedCollections(newSelectedProjects);
      } else {
        setSelectedCollections([...selectedCollections, p]);
      }
      let temp = { ...checked };
      temp[p.id] = !checked[p.id];
      setChecked(temp);
    };

    return (
      <Dialog
        open={visible}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="lg"
        fullWidth={true}
      >
        <DialogTitle id="alert-dialog-title">
          Import your projects{" "}
          <IconButton
            aria-label="close"
            onClick={() => handleClose()}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <SuiBox display="flex" alignItems="center" justifyContent="space-between" gap={1}>
            <SuiBox></SuiBox>
            <SuiBox display="flex" alignItems="center" justifyContent="flex-end" gap={1}>
              <SuiBox>
                <Card sx={{ borderRadius: 2, width: 200 }}>
                  <SuiSelect
                    options={collectionSortOptions}
                    placeholder="Sort"
                    isClearable
                    onChange={handleOnSortChange}
                    value={orderOpt}
                  />
                </Card>
              </SuiBox>
              <SuiBox>
                <SuiInput
                  placeholder="Search Keywords"
                  type="text"
                  onChange={(e) => handleSearchChange(e?.target?.value)}
                  icon={{
                    direction: "right",
                    component: (
                      <SearchIcon
                        sx={{ cursor: "pointer" }}
                        onClick={() => handleSearchChange(searchStr)}
                      />
                    ),
                  }}
                />{" "}
              </SuiBox>
            </SuiBox>
          </SuiBox>
          <SuiBox>
            <SuiBox
              display="flex"
              justifyContent="flex-start"
              sx={{ flexWrap: "wrap", minHeight: 200 }}
            >
              <Grid container spacing={2}>
                {filteredCollectionList && filteredCollectionList.length > 0 ? (
                  filteredCollectionList.map((x, index) => (
                    <Grid item md={3}>
                      <CollectionCard
                        collection={x}
                        key={index}
                        isSelected={checked[x.id] ? true : false}
                        handleSelectStyle={(e) => handleCheckProject(x)}
                      />
                    </Grid>
                  ))
                ) : (
                  <Empty />
                )}
              </Grid>
            </SuiBox>
            <SuiBox
              display="flex"
              flexDirection={{ xs: "column", sm: "row" }}
              justifyContent="space-between"
              alignItems={{ xs: "flex-start", sm: "center" }}
              p={3}
            >
              <SuiBox display="flex" alignItems="center">
                <SuiBox mb={{ xs: 3, sm: 0 }}>
                  <SuiTypography variant="button" color="secondary" fontWeight="regular">
                    Showing {entriesStart} to {entriesEnd} of {totalNumber} entries
                  </SuiTypography>
                </SuiBox>

                <SuiBox display="flex" alignItems="center" gap={1}>
                  <SuiSelect
                    defaultValue={{ value: pageSize, label: pageSize }}
                    options={[10, 20, 50].map((entry) => ({ value: entry, label: entry }))}
                    onChange={handleChangeRowsPerPage}
                    size="small"
                  />

                  <SuiTypography variant="caption" color="secondary">
                    entries per page
                  </SuiTypography>
                </SuiBox>
              </SuiBox>
              <Pagination
                variant={"outlined"}
                color={"info"}
                count={pageOptions.length}
                defaultPage={page}
                onChange={handleChangePage}
              />
            </SuiBox>
          </SuiBox>
        </DialogContent>
        <DialogActions>
          <SuiButton variant="gradient" size="medium" onClick={handleClose} color="light">
            Cancel
          </SuiButton>
          <SuiButton
            size="medium"
            variant="gradient"
            color="dark"
            onClick={handleOk ? () => handleOk(selectedCollections) : null}
          >
            Import
          </SuiButton>
        </DialogActions>
      </Dialog>
    );
  }
);

export default ImportCollectionModal;
